import * as PIXI from "pixi.js";
import { config } from "./appConfig";
import { pixiApp } from "./initializePixi";
import { fruitData } from "./data";
import gsap from "gsap";
import { resolveAndKillTweens, tweenFadeAppear, tweenPulsate } from "./utility";
import { Spine } from "@esotericsoftware/spine-pixi-v7";
import { BuyTickets, formatBalance, handleAutoPlay, handlePlayGame, handleTurboPlay, populateBetPanel, populateRoundPanel, random } from "./gameLogic";
import { playAmbient, playCutWin, playDisable, playLoadingDone, playLoseBomb, playMinus, playOff, playPlus, playPopupOpen, playSlice, playTap } from "./soundManager";
import { MenuPopUp } from "./menuPopup";
import { Meter } from "./meter";
import { checkForPendingGame, isOnline } from "./gameService";
import { bgLady, lady, timeOut } from "./assetProgressBar";
import { winScreen } from "./winScreen";
import { setupCoins } from "./coins";
import { FTUE } from "./ftue";
import { jackpotPanel } from "./jackpotPanel";

const containers = {
  rootContainer: new PIXI.Container(),
  bgContainer: new PIXI.Container(),
  pageContainer: new PIXI.Container(),
  imageContainer: new PIXI.Container(),
  coinsContainer: new PIXI.Container(),
};

const gameAssets = {
  gameScreen: null,
  balanceText: null,
  balanceCoin: null,
  balanceAmount: null,
  betAmount: null,
  betPanelBtn: [],
  roundPanelBtn: [],
  roundNumber: [],
  betNumber: [],
  startText: null,
  playButtonText: null,
  bucketAnimation: null,
  bucketAmount: null,
  timeouts: [],
}

const instances = {
  MenuPopUp: null,
  Meter: null,
  FTUE: null,
  JackpotPanel: null,
};

const playAnimations = [
  "meter animation/spin/0",
  "meter animation/spin/1",
  "meter animation/spin/2",
  "meter animation/spin/3",
  "meter animation/spin/4",
  "meter animation/spin/5",
  "meter animation/spin/6",
  "meter animation/spin/7",
  "meter animation/spin/8",
  "meter animation/play/play_to_spin_transition",
  "meter animation/play/spin_to_play_transition",
];
let uiCreated = false;
const fruits = ['grape', 'apple', 'watermelon', 'strawberry', 'mango', 'pineapple', 'grape'];

function setupContainers() {
  pixiApp.app.stage.addChild(containers.rootContainer);
  containers.rootContainer.addChild(containers.bgContainer);
}

const resetPixiGame = (x, y) => {
  containers.rootContainer.x = 0;
  containers.rootContainer.y = 0;
};


function createAppUI(pixiStates) {
  setupContainers()
  setupGameScreen();

  setupLayout();
  setupCoins()
  setupPopup()
  setupLoadingScreen()
  setupFruit()
  setupCoinContainer()
  containers.bgContainer.addChild(gameAssets.gameScreen2)
  setupPrizeUpgrade()
  setupJackpotPanel()

  if (!fruitData.gameLanguage) setupFTUE()
  uiCreated = true

  resetPixiGame(pixiApp.app.screen.width, pixiApp.app.screen.height);

  checkForPendingGame();
  updateBalance(fruitData?.balance);
  populateBetPanel(fruitData?.betSettings);
  populateRoundPanel(fruitData?.roundSettings);
  fruitData.gameLoaded = true;
  fruitData.pixiStates = pixiStates;
  playLoadingDone(true)
  // playMainBg(true)


  resizeGameUI();

}

function setupJackpotPanel() {
  instances.JackpotPanel = new jackpotPanel();
  instances.JackpotPanel.jackpotPanelSprite.anchor.set(0.5)
  instances.JackpotPanel.jackpotPanelSprite.scale.set(config.minScaleFactor)
  instances.JackpotPanel.jackpotPanelSprite.x = 0
  instances.JackpotPanel.jackpotPanelSprite.y = 0
  gameAssets.gameScreen2.addChild(instances.JackpotPanel.jackpotPanelContainer);

  hideJackpotPanel();

}

function setupPrizeUpgrade() {
  gameAssets.prizeUpgrade = new PIXI.Sprite(PIXI.Assets.get('prizeUpgrade'));
  gameAssets.prizeUpgrade.anchor.set(0.5);
  gameAssets.prizeUpgrade.position.set(config.logicalWidth / 2, config.logicalHeight / 2)
  gameAssets.prizeUpgrade.scale.set(3.2);
  gameAssets.prizeUpgrade.alpha = 0;
  gameAssets.prizeUpgrade.visible = true;

  gameAssets.gameScreen.addChild(gameAssets.prizeUpgrade)
}

function setupCoinContainer() {
  gameAssets.CoinsContainer = new PIXI.Container();
  gameAssets.CoinsContainer.visible = true;

  for (let i = 1; i <= 6; i++) {
    const container = new PIXI.Container();
    container.visible = false;

    // Create 3 coins inside each container
    for (let j = 1; j <= 3; j++) {
      const coin = Spine.from({ skeleton: "particleSpine", atlas: "particleAtlas" });
      coin.scale.set(0.2);
      coin.state.setAnimation(0, "coin rotate", true);

      container.addChild(coin);

      // Store each coin in gameAssets for later access (optional)
      gameAssets[`Coin${i}_${j}`] = coin;
    }

    // Store each container in gameAssets
    gameAssets[`coinAnimationContainer${i}`] = container;
    gameAssets.CoinsContainer.addChild(container);
  }

  gameAssets.winNumber = new PIXI.BitmapText("333", {
    fontName: 'purple-font',
    fontSize: 12,
    align: 'center',
    letterSpacing: -15,
    resolution: 2
  });
  gameAssets.winNumber.anchor.set(0.5);
  gameAssets.winNumber.alpha = 0;

  gameAssets.CoinsContainer.addChild(gameAssets.winNumber)

  containers.bgContainer.addChild(gameAssets.CoinsContainer);
}

function toggleButtons(isTrue) {
  gameAssets.menubarButton.interactive = isTrue;
  gameAssets.roundMinusHitGraphic.interactive = isTrue;
  gameAssets.roundPlusHitGraphic.interactive = isTrue;
  gameAssets.betMinusHitGraphic.interactive = isTrue;
  gameAssets.betPlusHitGraphic.interactive = isTrue;
  gameAssets.playHitGraphic.interactive = isTrue;
  gameAssets.autoHitGraphic.interactive = isTrue;
  gameAssets.turboHitGraphic.interactive = isTrue;
  gameAssets.betHitGraphic.interactive = isTrue;
  gameAssets.roundPanelHitGraphic.interactive = isTrue;
}

function setupFTUE() {
  if (!fruitData.language) {
    toggleButtons(false)
    instances.FTUE = new FTUE()
  }
}

function setupPopup() {
  gameAssets.popupContainer = new PIXI.Container();

  gameAssets.popup = new PIXI.Sprite(PIXI.Assets.get("popup_board"));
  gameAssets.popup.anchor.set(0.5);
  gameAssets.popup.visible = false;
  // gameAssets.popupContainer.visible = false;

  gameAssets.popupDimmer = new PIXI.Sprite(PIXI.Assets.get("dimmer"));
  gameAssets.popupDimmer.anchor.set(0.5);
  gameAssets.popupDimmer.y = 0;
  gameAssets.popupDimmer.visible = false;

  if (/Mobi|Android|iPhone/i.test(navigator?.userAgent)) {
    gameAssets.popupDimmer.scale.set(0.75, 2)
  } else {
    gameAssets.popupDimmer.scale.set(0.67, 2)
  }

  gameAssets.popupText = new PIXI.BitmapText("INSUFFICIENT\nBALANCE", {
    fontName: 'normal-font',
    fontSize: 25,
    align: 'center',
    letterSpacing: -10,
    resolution: 2

  });
  gameAssets.popupText.anchor.set(0.5)
  gameAssets.popupText.y = 0
  gameAssets.popupText.scale.set(0.6)

  const closeBtn = new PIXI.Sprite(PIXI.Assets.get("close_b_normal"));
  closeBtn.anchor.set(0.5);
  closeBtn.interactive = true;
  closeBtn.cursor = 'pointer'
  closeBtn.scale.set(0.65)
  closeBtn.position.set(275, -220)

  closeBtn.on('pointerover', () => {
    closeBtn.texture = PIXI.Assets.get("close_b_selected");
  });

  closeBtn.on('pointerout', () => {
    closeBtn.texture = PIXI.Assets.get("close_b_normal");
  });

  closeBtn.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      disablePopup()
      toggleButtons(true)
    }
  })

  gameAssets.popup.addChild(gameAssets.popupText, closeBtn);

  gameAssets.popupContainer.addChild(gameAssets.popupDimmer, gameAssets.popup);
  gameAssets.popupContainer.addChild(instances.winScreen.winContainer)
  containers.bgContainer.addChild(gameAssets.popupContainer)
}

function disablePopup() {
  gameAssets.popup.visible = false;
  gameAssets.popupDimmer.visible = false;
}

function showErrorPopup(popUpText = "NETWORK\nERROR", description = "! Not enough balance") {
  gameAssets.popup.visible = true;
  gameAssets.popupDimmer.visible = true;

  gameAssets.popupText.text = popUpText;

}

function setupLayout() {

  gameAssets.background = new PIXI.Sprite(PIXI.Assets.get("background"));
  gameAssets.background.anchor.set(0.5);
  gameAssets.background.x = config.logicalWidth * 0.5
  gameAssets.background.y = config.logicalHeight * 0.528
  gameAssets.background.width = config.logicalWidth
  gameAssets.background.height = config.logicalHeight + 1250


  gameAssets.backgroundAnimation = Spine.from({ skeleton: "backgroundSpine", atlas: "backgroundAtlas" });
  gameAssets.backgroundAnimation.scale.set(1, 2);
  gameAssets.backgroundAnimation.x = config.logicalWidth / 2;
  gameAssets.backgroundAnimation.y = 0;
  gameAssets.backgroundAnimation.state.setAnimation(0, "ambient animation", true);

  gameAssets.startText = new PIXI.Text('PLACE YOUR\nBET!', {
    fontFamily: 'LuckyGuy',
    fontSize: 130,
    align: 'center',
    fill: '#FFFF00',
    fontWeight: 400,
    letterSpacing: 0
  });
  gameAssets.startText.x = 720
  gameAssets.startText.y = config.logicalHeight * 0.65
  gameAssets.startText.anchor.set(0.5);

  gameAssets.gameScreen.addChild(
    gameAssets.background,
    gameAssets.backgroundAnimation,
    gameAssets.startText
  );

  setupGameUI()

}


function setSessionExpired() {
  if (!fruitData.pixiStates) return;
  fruitData.pixiStates.setSessionExpired(true)
}

function setupGameUI() {
  gameAssets.gameUI = new PIXI.Sprite(PIXI.Assets.get('baseContainer'));
  gameAssets.gameUI.anchor.set(0.5);
  gameAssets.gameUI.visible = false;
  gameAssets.gameUI.sortableChildren = true;
  gameAssets.gameUI.scale.set(3)
  gameAssets.gameUI.x = 730
  gameAssets.gameUI.y = 2600

  containers.bgContainer.addChild(gameAssets.gameUI);

  instances.MenuPopUp = new MenuPopUp();
  if (fruitData.gameLanguage) {
    instances.MenuPopUp.showTutorial(fruitData.gameLanguage == 'tl' ? "tag" : 'eng')
    instances.MenuPopUp.setActiveLanguage(fruitData.gameLanguage)
  }

  instances.winScreen = new winScreen();
  gameAssets.gameScreen.addChild(instances.MenuPopUp.menuPopUp);

  setupMenuButton();

  setupPlayButton();

  setupAutoPlay();

  setupTurboPlay();

  if (!fruitData.showAutoAndTurbo) {
    gameAssets.autoPlayNormal.visible = false;
    gameAssets.turboPlayNormal.visible = false;
  }

  setupBetPanel();

  setupRoundsPanel()

  setupBalanceSection();

  setupTotalBetSection();

  setUpMeter();

  setupBucketBalance()

  gameAssets.roundPlusNormal = new PIXI.Sprite(PIXI.Assets.get('plus_b_normal'));
  gameAssets.roundPlusNormal.anchor.set(0.5);
  gameAssets.roundPlusNormal.scale.set(0.4);
  gameAssets.roundPlusNormal.x = 216;
  gameAssets.roundPlusNormal.y = -110;

  gameAssets.roundPlusHover = new PIXI.Sprite(PIXI.Assets.get('plus_b_selected'));
  gameAssets.roundPlusHover.anchor.set(0.5);
  gameAssets.roundPlusHover.visible = false;

  gameAssets.roundPlusHitGraphic = new PIXI.Graphics();
  gameAssets.roundPlusHitGraphic.beginFill(0x202020, 1);
  gameAssets.roundPlusHitGraphic.drawCircle(1, -5, 41);
  gameAssets.roundPlusHitGraphic.endFill();
  gameAssets.roundPlusHitGraphic.interactive = true;
  gameAssets.roundPlusHitGraphic.alpha = 0
  gameAssets.roundPlusHitGraphic.cursor = "pointer";

  gameAssets.roundPlusHitGraphic.on('pointerover', () => {
    gameAssets.roundPlusHover.visible = true;
  })

  gameAssets.roundPlusHitGraphic.on('pointerout', () => {
    gameAssets.roundPlusHover.visible = false;
  })

  gameAssets.roundPlusHitGraphic.on('pointerupoutside', () => {
    gameAssets.roundPlusHover.visible = false;
  })

  gameAssets.roundPlusHitGraphic.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      gameAssets.roundPlusHover.visible = false;
      if (fruitData.roundPointer < fruitData.roundSettings.length - 1) {
        playPlus(true);
        fruitData.roundPointer += 1;
        gameAssets.roundPanelText.text = fruitData.roundSettings[fruitData.roundPointer]
        instances.Meter.heartText.text = instances.Meter.multipliers[fruitData.roundSettings[fruitData.roundPointer]].length
        const currIndex = fruitData.roundSettings[fruitData.roundPointer];
        fruitData.totalRounds = fruitData.roundSettings[fruitData.roundPointer];
        instances.Meter.meterHolder[fruitData.roundSettings[fruitData.roundPointer - 1]].visible = false;
        instances.Meter.meterHolder[currIndex].visible = true;
        instances.Meter.createMultipliers(currIndex);
      } else {
        playDisable(true)
      }
    }
  })

  gameAssets.roundMinusNormal = new PIXI.Sprite(PIXI.Assets.get('minus_b_normal'));
  gameAssets.roundMinusNormal.anchor.set(0.5);
  gameAssets.roundMinusNormal.scale.set(0.4);
  gameAssets.roundMinusNormal.x = 105;
  gameAssets.roundMinusNormal.y = -110;

  gameAssets.roundMinusHover = new PIXI.Sprite(PIXI.Assets.get('minus_b_selected'));
  gameAssets.roundMinusHover.anchor.set(0.5);
  gameAssets.roundMinusHover.visible = false;

  gameAssets.roundMinusHitGraphic = new PIXI.Graphics();
  gameAssets.roundMinusHitGraphic.beginFill(0x202020, 1);
  gameAssets.roundMinusHitGraphic.drawCircle(1, -5, 41);
  gameAssets.roundMinusHitGraphic.endFill();
  gameAssets.roundMinusHitGraphic.interactive = true;
  gameAssets.roundMinusHitGraphic.alpha = 0
  gameAssets.roundMinusHitGraphic.cursor = "pointer";

  gameAssets.roundMinusHitGraphic.on('pointerover', () => {
    gameAssets.roundMinusHover.visible = true;
  })

  gameAssets.roundMinusHitGraphic.on('pointerout', () => {
    gameAssets.roundMinusHover.visible = false;
  })

  gameAssets.roundMinusHitGraphic.on('pointerupoutside', () => {
    gameAssets.roundMinusHover.visible = false;
  })

  gameAssets.roundMinusHitGraphic.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      gameAssets.roundMinusHover.visible = false;
      if (fruitData.roundPointer > 0) {
        playMinus(true);
        fruitData.roundPointer -= 1;
        gameAssets.roundPanelText.text = fruitData.roundSettings[fruitData.roundPointer];
        instances.Meter.heartText.text = instances.Meter.multipliers[fruitData.roundSettings[fruitData.roundPointer]].length
        const currIndex = fruitData.roundSettings[fruitData.roundPointer];
        fruitData.totalRounds = fruitData.roundSettings[fruitData.roundPointer];
        instances.Meter.meterHolder[fruitData.roundSettings[fruitData.roundPointer + 1]].visible = false;
        instances.Meter.meterHolder[currIndex].visible = true;
        instances.Meter.createMultipliers(currIndex);
      } else {
        playDisable(true)
      }
    }
  })

  gameAssets.roundPanelPopup = new PIXI.Sprite(PIXI.Assets.get('rounds_select_panel_frame'));
  gameAssets.roundPanelPopup.anchor.set(0.5);
  gameAssets.roundPanelPopup.scale.set(0.5);
  gameAssets.roundPanelPopup.visible = false;
  gameAssets.roundPanelPopup.x = 165;
  gameAssets.roundPanelPopup.y = -178;

  for (let i = 0; i < 9; i++) {
    gameAssets.roundPanelBtn[i] = new PIXI.Sprite(PIXI.Assets.get('bet_select_panel_btn'));
    gameAssets.roundPanelBtn[i].anchor.set(0.5);
    gameAssets.roundPanelBtn[i].scale.set(1.65);

    const col = i % 3;
    const row = Math.floor(i / 3);

    if (col === 0) gameAssets.roundPanelBtn[i].x = -65;
    else if (col === 1) gameAssets.roundPanelBtn[i].x = 0;
    else if (col === 2) gameAssets.roundPanelBtn[i].x = 65;

    if (row === 0) gameAssets.roundPanelBtn[i].y = -50;
    else if (row === 1) gameAssets.roundPanelBtn[i].y = 2;
    else if (row === 2) gameAssets.roundPanelBtn[i].y = 55;

    gameAssets.roundPanelPopup.addChild(gameAssets.roundPanelBtn[i]);
  }

  gameAssets.roundPlusNormal.addChild(gameAssets.roundPlusHover, gameAssets.roundPlusHitGraphic)
  gameAssets.roundMinusNormal.addChild(gameAssets.roundMinusHover, gameAssets.roundMinusHitGraphic);

  gameAssets.gameUI.addChild(gameAssets.roundPanelPopup, gameAssets.roundMinusNormal, gameAssets.roundPlusNormal)

}

function triggerRapidFruitFall() {
  fruitData.isRapidFallActive = true;
  const startTime = performance.now();
  const duration = 5000; // 5 seconds

  function spawnRandomFruit() {
    if (!fruitData.isRapidFallActive) return;

    const currentTime = performance.now();
    if (currentTime - startTime >= duration) {
      fruitData.isRapidFallActive = false;
      return;
    }

    spawnAndCutFruit();

    // Schedule next fruit spawn at random interval between 50ms and 200ms
    const nextDelay = 50 + Math.random() * 150;
    setTimeout(spawnRandomFruit, nextDelay);
  }

  spawnRandomFruit();
}


function spawnAndCutFruit() {
  const value = Math.floor(Math.random() * fruits.length);

  const fruit = Spine.from({ skeleton: "fruitSpine", atlas: "fruitAtlas" });
  fruit.scale.set(0.8);
  fruit.x = config.logicalWidth / 2 + (Math.random() * 900 - 430);
  fruit.y = -fruit.height - 400;

  fruit.state.setAnimation(0, `fruit animation/rotating/${fruits[value]}_idle`, true);

  fruit.name = fruits[value] === 'grape' ? 'grapes' : fruits[value];

  gameAssets.gameScreen.addChild(fruit);

  const startY = fruit.y;
  const endY = gameAssets.gameScreen.height + fruit.height - 200;

  gsap.to(fruit, {
    y: endY,
    duration: 1.5,
    ease: "power1.in",
    onUpdate: function () {
      const progress = (fruit.y - startY) / (endY - startY);
      if (!fruit.wasCut && progress >= 0.5) {
        fruit.wasCut = true;

        // Create and play the cut animation
        const cut = Spine.from({ skeleton: "playButtonSpine", atlas: "playButtonAtlas" });
        cut.x = fruit.x;
        cut.y = fruit.y;

        if (Math.round(Math.random())) {
          cut.scale.set(1.35);
          cut.state.setAnimation(0, `ui animation/slice1`, false);
          playSlice(true);
        } else {
          cut.scale.set(1.1);
          playSlice(true);
          cut.state.setAnimation(0, `ui animation/slice2`, false);
        }

        gameAssets.gameScreen.addChild(cut);

        cut.state.addListener({
          complete: function (entry) {
            gameAssets.gameScreen.removeChild(cut);
          }
        });

        // Play the fruit cut animation
        fruit.state.setAnimation(0, `fruit animation/fruit slice/fruit_cut_${fruit.name}`, false);

        if (fruitData.roundCount) {
          instances.Meter.addFruit(fruit.name);
          fruitData.roundCount -= 1;
        }

        // Create and play the success effect animation at the cut position
        const result = Spine.from({ skeleton: "fruitEffectSpine", atlas: "fruitEffectAtlas" });
        result.x = fruit.x;
        result.y = fruit.y;
        result.scale.set(0.7)
        result.state.setAnimation(0, 'fruit_cut_success', false);

        gameAssets.gameScreen.addChild(result);

        result.state.addListener({
          complete: function (entry) {
            gameAssets.gameScreen.removeChild(result);
          }
        });
      }
    },
    onComplete: () => {
      gameAssets.gameScreen.removeChild(fruit);
    }
  });
}




function setupBucketBalance() {
  gameAssets.bucketContainer = new PIXI.Container();
  gameAssets.bucketContainer.visible = false;

  gameAssets.bucketAnimation = Spine.from({ skeleton: "playButtonSpine", atlas: "playButtonAtlas" });
  gameAssets.bucketAnimation.state.setAnimation(0, 'ui animation/gain effects1', true);
  gameAssets.bucketAnimation.position.set(170, -160);
  gameAssets.bucketAnimation.scale.set(0.3);
  gameAssets.bucketAnimation.state.timeScale = 0.35;

  gameAssets.bucketAmount = new PIXI.BitmapText("₱0.5", {
    fontName: 'amber-font',
    fontSize: 7,
    align: 'center',
    letterSpacing: -5,
    resolution: 2

  });
  gameAssets.bucketAmount.visible = false;

  gameAssets.bucketAmount.anchor.set(0.5)

  gameAssets.bucketAmount.position.set(165, -175)

  gameAssets.bucketContainer.addChild(gameAssets.bucketAnimation, gameAssets.bucketAmount)

  gameAssets.gameUI.addChild(gameAssets.bucketContainer);
}

gameAssets.currentIndex = 1;

function swipeFruit(fruit) {
  if (fruitData.currentRound >= fruitData.totalRounds) return;
  if (fruit.name == 'grape') fruit.name = 'grapes';

  const cut = gameAssets.cut;
  cut.visible = true;
  cut.x = fruit.x;
  cut.y = fruit.y;
  playSlice(true)

  const globalPos = fruit.parent.toGlobal(fruit.position);

  if (Math.round(Math.random())) {
    cut.scale.set(1.35);
    cut.state.setAnimation(0, `ui animation/slice1`, false);
  } else {
    cut.scale.set(1.1);
    cut.state.setAnimation(0, `ui animation/slice2`, false);
  }

  fruit.state.setAnimation(0, `fruit animation/fruit slice/fruit_cut_${fruit.name}`, false);

  gameAssets.resultAnimate.visible = true;
  gameAssets.resultAnimate.x = fruit.x;
  gameAssets.resultAnimate.y = fruit.y;

  if (window.navigator.vibrate && fruitData.vibration) {
    window.navigator.vibrate(200); // Vibrate for 100ms
  }
  if (fruitData.roundValues[fruitData.currentRound] == 'coin') {
    playCutWin(true)
    gameAssets.resultAnimate.state.setAnimation(0, 'fruit_cut_success', false);
    fruitData.currentRound += 1;
    instances.Meter.addFruit(fruit.name);
    handlePlayGame([fruit.name], globalPos)
  } else {
    gameAssets.resultAnimate.state.setAnimation(0, 'fruit_cut_fail', false);
    fruitData.currentRound += 1;
    handlePlayGame(['bomb']);
    setTimeout(() => {
      playLoseBomb(true)
    }, 400)
  }

}

let vx = 6;
let vy = -50;
let gravity = 0.35;
let xGravity = 0.001;

let fvy, fvx, fGravity, fxGravity;

const controlGravity = [0.5, 0.38, 0.45, 0.4, 0.48, 0.53, 0.34];

let fruitLaunchInterval = null;

function fly1() {
  const f = gameAssets.fruit1;

  gsap.to(f, {
    duration: 0.01,
    y: f.y + f.vy,
    x: f.x + f.vx,
    onComplete: () => {
      f.vy += f.gravity;
      f.vx -= f.xGravity;

      if ((fruitData.autoPlay || fruitData.timer) && f.vy > -23 && f.vy < 15 && fruitData.num == 1) {
        fruitData.num = -1;
        fruitData.timer = false;
        swipeFruit(f);

        if (!fruitData.autoPlay) {
          gameAssets.tween = startCircularTimer(gameAssets.timer, 10);
        } else {
          const delay = fruitData.turboPlay ? 500 : 3500;
          gameAssets.timeouts.push(setTimeout(() => random(), delay));
        }

        gameAssets.timeouts.push(setTimeout(() => {
          startFruitLauncher(0)
        }, 1000));
        return;
      }

      if (f.y >= fruitData.startY) {
        startFruitLauncher(0)
      } else {
        fly1();
      }
    }
  });
}

function fly2() {
  const f = gameAssets.fruit2;
  gsap.to(f, {
    duration: 0.01,
    y: f.y + f.fvy,
    x: f.x + f.fvx,
    onComplete: () => {
      f.fvy += f.fGravity;
      f.fvx -= f.fxGravity;

      if ((fruitData.autoPlay || fruitData.timer) && f.fvy > -20 && f.fvy < 19 && fruitData.num == 0) {
        fruitData.num = -1;
        fruitData.timer = false;
        swipeFruit(f);

        if (!fruitData.autoPlay) {
          gameAssets.tween = startCircularTimer(gameAssets.timer, 10);
        } else {
          const delay = fruitData.turboPlay ? 500 : 3500;
          gameAssets.timeouts.push(setTimeout(() => random(), delay));
        }

        gameAssets.timeouts.push(setTimeout(() => {
          startFruitLauncher(1)
        }, 1000));
        return;
      }

      if (f.y >= fruitData.startY) {
        startFruitLauncher(1)
      } else {
        fly2();
      }
    }
  });
}

function fly3() {
  const f = gameAssets.fruit3;
  gsap.to(f, {
    duration: 0.01,
    y: f.y + f.fvy,
    x: f.x + f.fvx,
    onComplete: () => {
      f.fvy += f.fGravity;
      f.fvx -= f.fxGravity;

      if ((fruitData.autoPlay || fruitData.timer) && f.fvy > -20 && f.fvy < 19 && fruitData.num == 2) {
        fruitData.num = -1;
        fruitData.timer = false;
        swipeFruit(f);

        if (!fruitData.autoPlay) {
          gameAssets.tween = startCircularTimer(gameAssets.timer, 10);
        } else {
          const delay = fruitData.turboPlay ? 500 : 3500;
          gameAssets.timeouts.push(setTimeout(() => random(), delay));
        }

        gameAssets.timeouts.push(setTimeout(() => {
          startFruitLauncher(2)
        }, 1000));
        return;
      }

      if (f.y >= fruitData.startY) {
        startFruitLauncher(2)
      } else {
        fly3();
      }
    }
  });
}

function fly4() {
  const f = gameAssets.fruit4;
  gsap.to(f, {
    duration: 0.01,
    y: f.y + f.fvy,
    x: f.x + f.fvx,
    onComplete: () => {
      f.fvy += f.fGravity;
      f.fvx -= f.fxGravity;

      if ((fruitData.autoPlay || fruitData.timer) && f.fvy > -20 && f.fvy < 19 && fruitData.num == 3) {
        fruitData.num = -1;
        fruitData.timer = false;
        swipeFruit(f);

        if (!fruitData.autoPlay) {
          gameAssets.tween = startCircularTimer(gameAssets.timer, 10);
        } else {
          const delay = fruitData.turboPlay ? 500 : 3500;
          gameAssets.timeouts.push(setTimeout(() => random(), delay));
        }

        gameAssets.timeouts.push(setTimeout(() => {
          startFruitLauncher(3)
        }, 1000));
        return;
      }

      if (f.y >= fruitData.startY) {
        startFruitLauncher(3)
      } else {
        fly4();
      }
    }
  });
}

const fruitSizeMap = {
  strawberry: 0.73,
  grape: 0.8,
  apple: 0.85,
  mango: 0.93,
  banana: 0.95,
  pineapple: 1.02,
  watermelon: 1.1,
};

let lastRandom = null;

function launchFruit(fruitKey, isDelayed = false) {
  if (!fruitData.play) return;

  let random;
  do {
    random = Math.floor(Math.random() * 3);
  } while (random === lastRandom);
  lastRandom = random;

  const value = Math.floor(Math.random() * fruits.length);

  const fruit = gameAssets[fruitKey];
  const isFruit1 = fruitKey === "fruit1";
  const isFruit2 = fruitKey === "fruit2";
  const isFruit3 = fruitKey === "fruit3";

  fruit.y = config.logicalHeight + 70;
  const velocityY = -40;
  const gravityVal = controlGravity[value];

  let x = 0, vx = 0, xGravity = 0;

  if (random === 0) {
    x = 75;
    vx = 6;
    xGravity = 0.001;
  } else if (random === 1) {
    x = 625;
    vx = 0;
    xGravity = 0;
  } else {
    x = 1400;
    vx = -5;
    xGravity = 0.01;
  }

  fruit.x = x;
  fruit.name = fruits[value];
  fruit.state.setAnimation(0, `fruit animation/rotating/${fruits[value]}_idle`, true);
  fruit.interactive = true
  const scaleVal = fruitSizeMap[fruit.name] || 1;
  fruit.scale.set(scaleVal);

  if (isFruit1) {
    fruit.visible = true;
    fruit.vy = velocityY;
    fruit.vx = vx;
    fruit.gravity = gravityVal;
    fruit.xGravity = xGravity;
  } else if (isFruit2) {
    fruit.visible = true;
    fruit.fvy = velocityY;
    fruit.fvx = vx;
    fruit.fGravity = gravityVal;
    fruit.fxGravity = xGravity;
  } else if (isFruit3) {
    fruit.visible = true;
    fruit.fvy = velocityY;
    fruit.fvx = vx;
    fruit.fGravity = gravityVal;
    fruit.fxGravity = xGravity;
  } else {
    fruit.visible = true;
    fruit.fvy = velocityY;
    fruit.fvx = vx;
    fruit.fGravity = gravityVal;
    fruit.fxGravity = xGravity;
  }

  const delay = isDelayed ? 1000 : 0;
  gameAssets.timeouts.push(setTimeout(() => {
    if (isFruit1) fly1();
    else if (isFruit2) fly2();
    else if (isFruit3) fly3();
    else fly4()
  }, delay));
}


function startFruitLauncher(num) {

  const baseDelay = fruitData.turboPlay ? 0 : 1000;
  fruitLaunchInterval = setTimeout(() => {
    const slots = ["fruit1", "fruit2", "fruit3", "fruit4"];
    const fruitKey = slots[num];
    launchFruit(fruitKey);
  }, baseDelay);
}

function stopFruitLauncher() {
  if (fruitLaunchInterval) {
    clearTimeout(fruitLaunchInterval);
    fruitLaunchInterval = null;
  }
}



function setupFruit() {
  gameAssets.fruit1 = Spine.from({ skeleton: "fruitSpine", atlas: "fruitAtlas" });
  gameAssets.fruit1.y = config.logicalHeight + 70;
  gameAssets.fruit1.x = 75;
  gameAssets.fruit1.scale.set(0.9);
  fruitData.startY = config.logicalHeight + 71;
  gameAssets.fruit1.interactive = true

  gameAssets.fruit2 = Spine.from({ skeleton: "fruitSpine", atlas: "fruitAtlas" });
  gameAssets.fruit2.y = gameAssets.gameUI.y + 50;
  gameAssets.fruit2.x = 75;
  gameAssets.fruit2.scale.set(0.9)
  gameAssets.fruit2.interactive = true

  gameAssets.fruit3 = Spine.from({ skeleton: "fruitSpine", atlas: "fruitAtlas" });
  gameAssets.fruit3.y = gameAssets.gameUI.y + 50;
  gameAssets.fruit3.x = 75;
  gameAssets.fruit3.scale.set(0.9)
  gameAssets.fruit3.interactive = true;

  gameAssets.fruit4 = Spine.from({ skeleton: "fruitSpine", atlas: "fruitAtlas" });
  gameAssets.fruit4.y = gameAssets.gameUI.y + 50;
  gameAssets.fruit4.x = 75;
  gameAssets.fruit4.scale.set(0.9)
  gameAssets.fruit4.interactive = true


  gameAssets.cut = Spine.from({ skeleton: "playButtonSpine", atlas: "playButtonAtlas" });
  gameAssets.resultAnimate = Spine.from({ skeleton: "fruitEffectSpine", atlas: "fruitEffectAtlas" });
  gameAssets.resultAnimate.name = 'result';
  gameAssets.cut.name = "cut_spine";

  gameAssets.resultAnimations = [];
  gameAssets.cutAnimation = [];
  gameAssets.gameScreen.addChild(gameAssets.fruit1, gameAssets.fruit2, gameAssets.fruit3, gameAssets.fruit4)

  for (let i = 0; i < 4; i++) {
    const anim = Spine.from({ skeleton: "fruitEffectSpine", atlas: "fruitEffectAtlas" });
    anim.name = 'result';
    gameAssets.resultAnimations.push(anim);
    gameAssets.gameScreen.addChild(anim);
  }

  for (let i = 0; i < 4; i++) {
    const anim = Spine.from({ skeleton: "playButtonSpine", atlas: "playButtonAtlas" });
    anim.name = 'result';
    gameAssets.cutAnimation.push(anim);
    gameAssets.gameScreen.addChild(anim);
  }

  addSwipeDetection([gameAssets.fruit1, gameAssets.fruit2, gameAssets.fruit3, gameAssets.fruit4]);

  gameAssets.gameScreen.addChild(gameAssets.cut, gameAssets.resultAnimate);
}

function addSwipeDetection(fruitList) {
  let lastPos = null;
  let lastTime = null;
  let swiping = false;
  let resultPointer = 0;
  let cutPlayedThisSwipe = false;
  let fruitsCutThisSwipe = [];

  let globalPos;


  gameAssets.gameScreen.on('pointerdown', (event) => {
    lastPos = event.data.getLocalPosition(gameAssets.gameScreen);
    lastTime = performance.now();
    swiping = true;
    cutPlayedThisSwipe = false;
    fruitsCutThisSwipe = [];
    fruitList.forEach(f => f.wasCut = false);

    gameAssets.swipeTimeout = setTimeout(() => {
      if (swiping) {
        endSwipe();
      }
    }, 100);
  });

  gameAssets.gameScreen.on('pointermove', (event) => {
    if (!lastPos || !lastTime || !swiping) return;

    const currPos = event.data.getLocalPosition(gameAssets.gameScreen);
    const currTime = performance.now();
    const dx = currPos.x - lastPos.x;
    const dy = currPos.y - lastPos.y;
    const dt = currTime - lastTime;
    const speed = Math.sqrt(dx * dx + dy * dy) / dt;

    fruitList.forEach(fruit => {
      if (fruit.wasCut) return;

      const dist = Math.hypot(currPos.x - fruit.x, currPos.y - fruit.y);
      if (speed > 1.0 && dist < fruit.width / 2) {

        fruit.wasCut = true;

        const currentAnimation = fruit.state.getCurrent(0);
        if (!currentAnimation) return;

        const animName = currentAnimation.animation.name;
        const match = animName.match(/rotating\/(.*?)_idle/);
        let fruitName = match ? match[1] : "unknown";
        if (fruitName === "grape") fruitName = "grapes";

        const result = gameAssets.resultAnimations[resultPointer];
        const cut = gameAssets.cutAnimation[resultPointer]

        if (fruitData.currentRound >= fruitData.totalRounds || fruitName == 'unknown' || fruitData.bomb >= instances.Meter.multipliers[fruitData.roundSettings[fruitData.roundPointer]].length) return;
        // if (!cutPlayedThisSwipe) {

        cut.visible = true;
        cut.x = fruit.x;
        cut.y = currPos.y;

        fruitData.timer = false;

        if (Math.round(Math.random())) {
          cut.scale.set(1.35);
          cut.state.setAnimation(0, `ui animation/slice1`, false);
          playSlice(true);
        } else {
          cut.scale.set(1.1);
          playSlice(true);
          cut.state.setAnimation(0, `ui animation/slice2`, false);
          // }

          cutPlayedThisSwipe = true;
        }

        globalPos = fruit.parent.toGlobal(fruit.position);


        resultPointer += 1;
        if (resultPointer >= 4) resultPointer = 0;

        result.visible = true;
        result.x = fruit.x;
        result.y = fruit.y;

        fruit.state.setAnimation(0, `fruit animation/fruit slice/fruit_cut_${fruitName}`, false);
        fruit.interactive = false;

        const value = fruitData.roundValues[fruitData.currentRound];
        console.log("values-of", value, fruitData.currentRound);

        fruitData.currentRound = fruitData.currentRound + 1;
        if (fruitData.currentRound > fruitData.totalRounds) {
          debugger
        }
        if (value === 'coin') {
          playCutWin(true);
          result.state.setAnimation(0, 'fruit_cut_success', false);
          fruitsCutThisSwipe.push(fruitName);
          if (gameAssets.tween) gameAssets.tween.kill();
          gameAssets.tween = startCircularTimer(gameAssets.timer, 10);
        } else {
          result.state.setAnimation(0, 'fruit_cut_fail', false);
          setTimeout(() => playLoseBomb(true), 400);
          fruitsCutThisSwipe.push("bomb");
          fruitData.bomb += 1;
          if (gameAssets.tween) gameAssets.tween.kill();
          gameAssets.tween = startCircularTimer(gameAssets.timer, 10);
        }

      }
    });


    lastPos = currPos;
    lastTime = currTime;
  });

  function endSwipe() {
    if (!fruitData.play) return;
    if (window.navigator.vibrate && fruitData.vibration) {
      window.navigator.vibrate(200); // Vibrate for 100ms
    }

    if (fruitsCutThisSwipe.length > 0) {
      handlePlayGame([...fruitsCutThisSwipe], globalPos);
      fruitsCutThisSwipe.map((value) => {
        if (value != 'bomb')
          instances.Meter.addFruit(value);
      });

      fruitsCutThisSwipe = [];
    }
    swiping = false;
    lastPos = null;
    lastTime = null;

    if (gameAssets.swipeTimeout) {
      clearTimeout(gameAssets.swipeTimeout);
      gameAssets.swipeTimeout = null;
    }
  }

  gameAssets.gameScreen.on('pointerup', endSwipe);
  gameAssets.gameScreen.on('pointerupoutside', endSwipe);
}





function setUpMeter() {
  instances.Meter = new Meter();
  gameAssets.gameUI.addChild(instances.Meter.meterContainer);

}

function setupRoundsPanel() {
  const roundPanelContainer = new PIXI.Container();
  roundPanelContainer.x = -4
  roundPanelContainer.y = 0

  gameAssets.roundPanel = new PIXI.Sprite(PIXI.Assets.get('fruit_container'));
  gameAssets.roundPanel.anchor.set(0.5);
  gameAssets.roundPanel.scale.set(0.4);
  gameAssets.roundPanel.x = 165;
  gameAssets.roundPanel.y = -135;

  gameAssets.roundPanelHitGraphic = new PIXI.Graphics();
  gameAssets.roundPanelHitGraphic.beginFill(0x000000, 1);
  gameAssets.roundPanelHitGraphic.drawRect(-75, 35, 150, 45);
  gameAssets.roundPanelHitGraphic.endFill();
  gameAssets.roundPanelHitGraphic.alpha = 0;
  gameAssets.roundPanelHitGraphic.interactive = true;
  gameAssets.roundPanelHitGraphic.cursor = 'pointer';

  gameAssets.roundPanelHitGraphic.on('pointerdown', (event) => {
    event.stopPropagation();
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      toggleRoundPanel();
    }
  })

  gameAssets.roundPanelText = new PIXI.Text('SLICES', {
    fontFamily: 'LuckyGuy',
    fontSize: 43,
    align: 'center',
    fill: '#FFC800',
    fontWeight: 500,
    letterSpacing: 1
  });

  gameAssets.roundPanelText.y = 60;
  gameAssets.roundPanelText.anchor.set(0.5);


  gameAssets.roundPanel.addChild(gameAssets.roundPanelText, gameAssets.roundPanelHitGraphic)

  roundPanelContainer.addChild(gameAssets.roundPanel);
  gameAssets.gameUI.addChild(roundPanelContainer)
}

function setupBetPanel() {
  const betPanelContainer = new PIXI.Container();
  betPanelContainer.y = 5

  gameAssets.betPanel = new PIXI.Sprite(PIXI.Assets.get('bet_panel'));
  gameAssets.betPanel.anchor.set(0.5);
  gameAssets.betPanel.scale.set(0.47);
  gameAssets.betPanel.x = -160;
  gameAssets.betPanel.y = -120;

  gameAssets.betHitGraphic = new PIXI.Graphics();
  gameAssets.betHitGraphic.beginFill(0x000000, 1);
  gameAssets.betHitGraphic.drawRect(-70, -8, 145, 45);
  gameAssets.betHitGraphic.endFill();
  gameAssets.betHitGraphic.alpha = 0;
  gameAssets.betHitGraphic.interactive = true;
  gameAssets.betHitGraphic.cursor = 'pointer';

  gameAssets.betHitGraphic.on("pointerdown", (event) => {
    event.stopPropagation();
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      toggleBetPanel();
    }
  })

  gameAssets.betPlusNormal = new PIXI.Sprite(PIXI.Assets.get('plus_b_normal'));
  gameAssets.betPlusNormal.anchor.set(0.5);
  gameAssets.betPlusNormal.scale.set(0.4);
  gameAssets.betPlusNormal.x = -102;
  gameAssets.betPlusNormal.y = -112;

  gameAssets.betPlusHover = new PIXI.Sprite(PIXI.Assets.get('plus_b_selected'));
  gameAssets.betPlusHover.anchor.set(0.5);
  gameAssets.betPlusHover.visible = false;

  gameAssets.betPlusHitGraphic = new PIXI.Graphics();
  gameAssets.betPlusHitGraphic.beginFill(0x202020, 1);
  gameAssets.betPlusHitGraphic.drawCircle(1, -5, 41);
  gameAssets.betPlusHitGraphic.endFill();
  gameAssets.betPlusHitGraphic.interactive = true;
  gameAssets.betPlusHitGraphic.alpha = 0
  gameAssets.betPlusHitGraphic.cursor = "pointer";

  gameAssets.betMinusNormal = new PIXI.Sprite(PIXI.Assets.get('minus_b_normal'));
  gameAssets.betMinusNormal.anchor.set(0.5);
  gameAssets.betMinusNormal.scale.set(0.4);
  gameAssets.betMinusNormal.x = -216;
  gameAssets.betMinusNormal.y = -112;

  gameAssets.betMinusHover = new PIXI.Sprite(PIXI.Assets.get('minus_b_selected'));
  gameAssets.betMinusHover.anchor.set(0.5);
  gameAssets.betMinusHover.visible = false;

  gameAssets.betText = new PIXI.Text('', {
    fontFamily: 'LuckyGuy',
    fontSize: 48,
    align: 'center',
    fill: '0x000000',
    fontWeight: 500,
    letterSpacing: 0
  })
  gameAssets.betText.y = 10;
  gameAssets.betText.anchor.set(0.5);

  gameAssets.betPanelPopup = new PIXI.Sprite(PIXI.Assets.get('bet_select_panel_frame'));
  gameAssets.betPanelPopup.anchor.set(0.5);
  gameAssets.betPanelPopup.scale.set(0.5);
  gameAssets.betPanelPopup.visible = false;
  gameAssets.betPanelPopup.x = -158;
  gameAssets.betPanelPopup.y = -204;

  const betValues = fruitData.betSettings;

  gameAssets.betPanelBtn = [];

  const COL_SPACING = 65;
  const ROW_SPACING = 70;
  const BASE_Y = -100;
  const COL_POSITIONS = [-COL_SPACING, 0, COL_SPACING];

  let row = 0;
  let col = 0;


  for (let i = 0; i < betValues.length; i++) {
    const value = betValues[i];
    const isBig = value === 1000;

    if (isBig && col === 2) {
      col = 0;
      row++;
    }

    let button;

    if (isBig) {
      button = new PIXI.Sprite(PIXI.Assets.get("rounds_select_panel_btn_2"));
      button.scale.set(0.75, 1.11);

      button.anchor.set(0.5);
      button.y = BASE_Y + row * ROW_SPACING;

      if (col === 0) {
        button.x = (COL_POSITIONS[0] + COL_POSITIONS[1]) / 2;
      } else if (col === 1) {
        button.x = (COL_POSITIONS[1] + COL_POSITIONS[2]) / 2;
      }

      gameAssets.betPanelBtn.push(button);
      gameAssets.betPanelPopup.addChild(button);
      col += 2;
    } else {
      button = new PIXI.Sprite(PIXI.Assets.get("bet_select_panel_btn"));
      button.scale.set(1.9);
      button.anchor.set(0.5);
      button.x = COL_POSITIONS[col];
      button.y = BASE_Y + row * ROW_SPACING;

      gameAssets.betPanelBtn.push(button);
      gameAssets.betPanelPopup.addChild(button);
      col++;
    }

    if (col >= 3) {
      col = 0;
      row++;
    }
  }


  gameAssets.betMinusHitGraphic = new PIXI.Graphics();
  gameAssets.betMinusHitGraphic.beginFill(0x202020, 1);
  gameAssets.betMinusHitGraphic.drawCircle(1, -5, 41);
  gameAssets.betMinusHitGraphic.endFill();
  gameAssets.betMinusHitGraphic.interactive = true;
  gameAssets.betMinusHitGraphic.alpha = 0
  gameAssets.betMinusHitGraphic.cursor = "pointer";

  gameAssets.betPlusHitGraphic.on('pointerover', () => {
    gameAssets.betPlusHover.visible = true;
  })

  gameAssets.betPlusHitGraphic.on('pointerdown', (event) => {
    gameAssets.betPlusHover.visible = false;
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      if (fruitData.betPointer < fruitData.betSettings.length - 1) {
        fruitData.betPointer += 1;
        playPlus(true);
        gameAssets.betText.text = fruitData.betSettings[fruitData.betPointer];
        gameAssets.betAmount.text = fruitData.betSettings[fruitData.betPointer];
        fruitData.betAmount = fruitData.betSettings[fruitData.betPointer];
        instances.Meter.updateMultipliers();

        if (fruitData.balance < fruitData.betSettings[fruitData.betPointer]) {
          checkBalanceColor(true);
        }
      } else {
        playDisable(true);
      }
    }
  })

  gameAssets.betPlusHitGraphic.on('pointerout', () => {
    gameAssets.betPlusHover.visible = false;
  })

  gameAssets.betMinusHitGraphic.on('pointerover', () => {
    gameAssets.betMinusHover.visible = true;
  })

  gameAssets.betMinusHitGraphic.on('pointerdown', (event) => {
    gameAssets.betMinusHover.visible = false;

    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      if (fruitData.betPointer > 0) {
        fruitData.betPointer -= 1;
        playMinus(true);
        gameAssets.betText.text = fruitData.betSettings[fruitData.betPointer];
        gameAssets.betAmount.text = fruitData.betSettings[fruitData.betPointer];
        fruitData.betAmount = fruitData.betSettings[fruitData.betPointer];
        instances.Meter.updateMultipliers()

        if (fruitData.balance >= fruitData.betSettings[fruitData.betPointer]) {
          checkBalanceColor(false);
        }
      } else {
        playDisable(true);
      }
    }
  });


  gameAssets.betMinusHitGraphic.on('pointerout', () => {
    gameAssets.betMinusHover.visible = false;
  })

  gameAssets.betPlusNormal.addChild(gameAssets.betPlusHover, gameAssets.betPlusHitGraphic)
  gameAssets.betMinusNormal.addChild(gameAssets.betMinusHover, gameAssets.betMinusHitGraphic)

  gameAssets.betPanel.addChild(gameAssets.betText, gameAssets.betHitGraphic)

  betPanelContainer.addChild(gameAssets.betPanel, gameAssets.betPanelPopup, gameAssets.betPlusNormal, gameAssets.betMinusNormal);
  gameAssets.gameUI.addChild(betPanelContainer);

}

function setupTotalBetSection() {
  const betText = new PIXI.Text('TOTAL BET', {
    fontFamily: 'LuckyGuy',
    fontSize: 15,
    align: 'center',
    fill: '#FFC800',
    fontWeight: 500,
    letterSpacing: 1
  });

  betText.y = -57
  betText.x = 170
  betText.anchor.set(0.5)

  gameAssets.betAmount = new PIXI.Text('', {
    fontFamily: 'LuckyGuy',
    fontSize: 22,
    align: 'center',
    fill: '#FFFFFF',
    fontWeight: 500,
    letterSpacing: 0
  });

  gameAssets.betAmount.anchor.set(0.5);
  gameAssets.betAmount.x = 170;
  gameAssets.betAmount.y = -40

  gameAssets.gameUI.addChild(betText, gameAssets.betAmount)
}

function setupTurboPlay() {
  gameAssets.turboPlayNormal = new PIXI.Sprite(PIXI.Assets.get('speed_b_normal'));
  gameAssets.turboPlayNormal.anchor.set(0.5);
  gameAssets.turboPlayNormal.scale.set(0.45);
  gameAssets.turboPlayNormal.x = 60;
  gameAssets.turboPlayNormal.y = -73;

  gameAssets.turboPlayHover = new PIXI.Sprite(PIXI.Assets.get('speed_b_selected'));
  gameAssets.turboPlayHover.anchor.set(0.5);
  gameAssets.turboPlayHover.visible = false;

  gameAssets.turboHitGraphic = new PIXI.Graphics();
  gameAssets.turboHitGraphic.beginFill(0x202020, 1);
  gameAssets.turboHitGraphic.drawCircle(0, -4, 50);
  gameAssets.turboHitGraphic.endFill();
  gameAssets.turboHitGraphic.interactive = true;
  gameAssets.turboHitGraphic.alpha = 0
  gameAssets.turboHitGraphic.cursor = "pointer";

  gameAssets.turboHitGraphic.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      handleTurboPlay()
    }
  })

  gameAssets.turboPlayNormal.addChild(gameAssets.turboPlayHover, gameAssets.turboHitGraphic)
  gameAssets.gameUI.addChild(gameAssets.turboPlayNormal)
}

function setupAutoPlay() {
  gameAssets.autoPlayNormal = new PIXI.Sprite(PIXI.Assets.get('auto_b_normal'));
  gameAssets.autoPlayNormal.anchor.set(0.5);
  gameAssets.autoPlayNormal.scale.set(0.45);
  gameAssets.autoPlayNormal.x = -60;
  gameAssets.autoPlayNormal.y = -74;

  gameAssets.autoPlayHover = new PIXI.Sprite(PIXI.Assets.get('auto_b_selected'));
  gameAssets.autoPlayHover.anchor.set(0.5);
  gameAssets.autoPlayHover.visible = false;

  gameAssets.autoHitGraphic = new PIXI.Graphics();
  gameAssets.autoHitGraphic.beginFill(0x202020, 1);
  gameAssets.autoHitGraphic.drawCircle(0, -4, 50);
  gameAssets.autoHitGraphic.endFill();
  gameAssets.autoHitGraphic.interactive = true;
  gameAssets.autoHitGraphic.alpha = 0
  gameAssets.autoHitGraphic.cursor = "pointer";


  gameAssets.autoHitGraphic.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      handleAutoPlay()
    }
  })

  gameAssets.autoPlayNormal.addChild(gameAssets.autoPlayHover, gameAssets.autoHitGraphic)


  gameAssets.gameUI.addChild(gameAssets.autoPlayNormal)

}

function setupPlayButton() {
  gameAssets.playButtonContainer = new PIXI.Container();

  gameAssets.playButtonNormal = new PIXI.Sprite(PIXI.Assets.get('play_b_normal'));
  gameAssets.playButtonNormal.anchor.set(0.5);
  gameAssets.playButtonNormal.scale.set(0.45);
  gameAssets.playButtonNormal.y = -135;

  gameAssets.playButtonHover = new PIXI.Sprite(PIXI.Assets.get('play_b_selected'));
  gameAssets.playButtonHover.anchor.set(0.5);
  gameAssets.playButtonHover.visible = false;

  gameAssets.playButtonDown = new PIXI.Sprite(PIXI.Assets.get('play_b_down'));
  gameAssets.playButtonDown.anchor.set(0.5);
  gameAssets.playButtonDown.visible = false;

  gameAssets.playHitGraphic = new PIXI.Graphics();
  gameAssets.playHitGraphic.beginFill(0x202020, 1);
  gameAssets.playHitGraphic.drawCircle(0, -7, 140);
  gameAssets.playHitGraphic.endFill();
  gameAssets.playHitGraphic.interactive = true;
  gameAssets.playHitGraphic.alpha = 0
  gameAssets.playHitGraphic.name = "hit_play_graphic"
  gameAssets.playHitGraphic.cursor = "pointer";

  gameAssets.timer = new PIXI.Sprite(PIXI.Assets.get('timer_100'));
  gameAssets.timer.anchor.set(0.5);
  gameAssets.timer.width = 125;
  gameAssets.timer.height = 129
  gameAssets.timer.y = -135;
  gameAssets.timer.x = 1
  gameAssets.timer.visible = false;

  gameAssets.playButtonText = new PIXI.Text('4', {
    fontFamily: 'LuckyGuy',
    fontSize: 60,
    align: 'center',
    fill: '#FFFFFF',
    fontWeight: 500,
    letterSpacing: 1
  })
  gameAssets.playButtonText.y = 0
  gameAssets.playButtonText.visible = false;
  gameAssets.playButtonText.anchor.set(0.5);


  const timerMask = new PIXI.Graphics();
  timerMask.x = gameAssets.timer.x;
  timerMask.y = gameAssets.timer.y;
  gameAssets.timer.mask = timerMask;


  gameAssets.playHitGraphic.on("pointerover", () => {
    gameAssets.playButtonHover.visible = true
  });

  gameAssets.playHitGraphic.on('pointerout', () => {
    gameAssets.playButtonHover.visible = false;
  })


  gameAssets.playButtonAnimate = Spine.from({ skeleton: "playButtonSpine", atlas: "playButtonAtlas" });
  gameAssets.playButtonAnimate.scale.set(0.35)
  gameAssets.playButtonAnimate.y = -135

  gameAssets.playHitGraphic.on('pointerdown', async (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {

      gameAssets.playHitGraphic.interactive = false;
      gameAssets.playButtonHover.visible = false;
      gameAssets.playButtonDown.visible = true;
      const online = await isOnline();
      if (online) {
        BuyTickets()
      } else {
        showErrorPopup('INTERNET \nDISCONNECTED');
        gameAssets.playButtonDown.visible = false;
        gameAssets.playHitGraphic.interactive = true;
      }
    }

  })

  gameAssets.playButtonNormal.addChild(gameAssets.playButtonHover, gameAssets.playButtonDown)
  gameAssets.playButtonContainer.addChild(gameAssets.playButtonNormal, gameAssets.playButtonAnimate, gameAssets.timer, timerMask);
  gameAssets.playButtonNormal.addChild(gameAssets.playButtonText, gameAssets.playHitGraphic)
  gameAssets.gameUI.addChild(gameAssets.playButtonContainer);
}

function startCircularTimer(sprite, duration = 10) {
  const mask = sprite.mask;

  mask.clear();
  mask.beginFill(0xffffff);
  mask.drawCircle(0, 0, sprite.width / 2);
  mask.endFill();
  sprite.texture = PIXI.Assets.get('timer_100');

  const progressObj = { progress: 0 };
  let halfwayReached = false;
  let lowReached = false;

  const tween = gsap.to(progressObj, {
    progress: 1,
    duration: duration,
    ease: "none",
    onUpdate: () => {
      const radius = sprite.width / 2;
      const startAngle = -Math.PI / 2;
      const endAngle = startAngle - (Math.PI * 2 * (1 - progressObj.progress));

      mask.clear();
      mask.beginFill(0xffffff);
      mask.moveTo(0, 0);
      mask.arc(0, 0, radius, startAngle, endAngle, true);
      mask.lineTo(0, 0);
      mask.endFill();

      if (!halfwayReached && progressObj.progress >= 0.5) {
        halfwayReached = true;
        sprite.texture = PIXI.Assets.get('timer_50');
      }

      if (!lowReached && progressObj.progress >= 0.75) {
        lowReached = true;
        sprite.texture = PIXI.Assets.get('timer_25');
      }
    },
    onComplete: () => {
      fruitData.timer = true;
      console.log("Timer finished");
      random();

      sprite.texture = PIXI.Assets.get('timer_100');
      mask.clear();
      mask.beginFill(0xffffff);
      mask.drawCircle(0, 0, sprite.width / 2);
      mask.endFill();
    }
  });

  return tween;
}

function checkBalanceColor(isRed) {
  if (isRed) {
    gameAssets.balanceAmount.style.fill = '#FF0000';
  } else {
    gameAssets.balanceAmount.style.fill = '#FFFFFF';
  }
}


function updateBalance(bal = 1000) {
  gameAssets.balanceAmount.text = formatBalance(bal);

  const maxAllowedWidth = 110;
  const currentWidth = gameAssets.balanceAmount.width;

  if (currentWidth > maxAllowedWidth) {
    const scaleFactor = (maxAllowedWidth + 20) / currentWidth;

    if (scaleFactor > 0.9) {
      gameAssets.balanceAmount.scale.set(scaleFactor)
    } else {
      gameAssets.balanceAmount.scale.set(scaleFactor);
    }
  }
  if (bal < 1000) {
    gameAssets.balanceAmount.x = -190;
  } else if (bal < 10000) {
    gameAssets.balanceAmount.x = -195;
  } else {
    gameAssets.balanceAmount.x = -200;
  }
}

function setupBalanceSection() {
  gameAssets.balanceText = new PIXI.Text('BALANCE', {
    fontFamily: 'LuckyGuy',
    fontSize: 15,
    align: 'center',
    fill: '#FFC800',
    fontWeight: 500,
    letterSpacing: 1
  });

  gameAssets.balanceText.y = -57
  gameAssets.balanceText.x = -158
  gameAssets.balanceText.anchor.set(0.5)

  gameAssets.balanceCoin = new PIXI.Sprite(PIXI.Assets.get("giocoCoin"));
  gameAssets.balanceCoin.anchor.set(0.5);
  gameAssets.balanceCoin.scale.set(0.38);
  gameAssets.balanceCoin.y = -41;
  gameAssets.balanceCoin.x = -215;

  gameAssets.balanceAmount = new PIXI.Text('6799.90', {
    fontFamily: 'LuckyGuy',
    fontSize: 20,
    align: 'center',
    fill: '#FFFFFF',
    fontWeight: 500,
    letterSpacing: 0
  });
  gameAssets.balanceAmount.y = -40
  gameAssets.balanceAmount.x = -198

  gameAssets.balanceAmount.anchor.set(0, 0.5)

  gameAssets.gameUI.addChild(gameAssets.balanceText, gameAssets.balanceCoin, gameAssets.balanceAmount)
}

function setupGameScreen() {
  const backdrop = new PIXI.Sprite(PIXI.Assets.get("backdrop"));
  backdrop.anchor.set(0.5);
  backdrop.scale.set(1);
  backdrop.x = window.innerWidth / 2;
  backdrop.y = window.innerHeight * 0.53;
  // containers.bgContainer.addChild(backdrop);

  const gameMask = new PIXI.Sprite(PIXI.Assets.get("gameScreen"));
  gameMask.anchor.set(0.5);

  gameAssets.gameScreen = new PIXI.Container();

  const mask = new PIXI.Graphics();
  mask.beginFill(0xffffff);
  mask.drawRect(0, -1800, config.logicalWidth, config.logicalHeight + 3000);
  mask.endFill();
  gameAssets.gameScreen.addChild(mask);
  gameAssets.gameScreen.mask = mask;

  gameAssets.gameScreen2 = new PIXI.Container();
  containers.bgContainer.addChild(gameAssets.gameScreen)

}

function setupMenuButton() {
  gameAssets.menubarButton = new PIXI.Sprite(PIXI.Assets.get("menuNormal"));
  gameAssets.menubarButton.anchor.set(0.5);
  gameAssets.menubarButton.scale.set(config.minScaleFactor)
  gameAssets.menubarButton.x = window.innerWidth / 2 + 33
  gameAssets.menubarButton.y = gameAssets.menubarButton.height / 2 + 10
  gameAssets.gameScreen2.addChild(gameAssets.menubarButton);
  gameAssets.menubarButton.visible = false;
  gameAssets.menubarButton.interactive = true

  const menuButtonSelect = new PIXI.Sprite(PIXI.Assets.get("menuSelected"));
  menuButtonSelect.anchor.set(0.5);
  menuButtonSelect.visible = false;

  gameAssets.menuButtonDisable = new PIXI.Sprite(PIXI.Assets.get("menuDisabled"));
  gameAssets.menuButtonDisable.anchor.set(0.5);
  gameAssets.menuButtonDisable.visible = false;

  gameAssets.menubarButton.addChild(menuButtonSelect, gameAssets.menuButtonDisable);

  gameAssets.menubarButton.on("pointerover", () => {
    menuButtonSelect.visible = true;
    gameAssets.menubarButton.cursor = "pointer";
  });

  gameAssets.menubarButton.on("pointerout", () => {
    menuButtonSelect.visible = false;
  });

  gameAssets.menubarButton.on("pointerdown", () => {
    menuButtonSelect.visible = false;
    gameAssets.fruit1.visible = gameAssets.fruit2.visible = false;
    fruitData.play = false;
    instances.MenuPopUp.enable()
    playPopupOpen(true)
  });
}


async function setupLoadingScreen() {

  gameAssets.loadingScreen = new PIXI.Sprite(PIXI.Assets.get('fruitIntroBg'))
  gameAssets.loadingScreen.zIndex = 100
  gameAssets.loadingScreen.anchor.set(0.5)
  gameAssets.loadingScreen.scale.set(1)
  gameAssets.loadingScreen.x = config.logicalWidth / 2
  gameAssets.loadingScreen.y = config.logicalHeight / 2
  gameAssets.loadingScreen.initialX = gameAssets.loadingScreen.finalX = gameAssets.loadingScreen.x
  gameAssets.loadingScreen.initialY = gameAssets.loadingScreen.finalY = gameAssets.loadingScreen.y

  const logo = new PIXI.Sprite(PIXI.Assets.get('fruitLogo'))
  logo.anchor.set(0.5)
  logo.scale.set(1.25)
  logo.x = 0
  logo.y = -895

  bgLady.y = config.logicalHeight / 2 - 100
  bgLady.x = 0

  lady.y = config.logicalHeight / 2 - 285
  lady.x = 0

  gameAssets.loadingScreen.addChild(bgLady, logo, lady)
  gameAssets.gameScreen.addChild(gameAssets.loadingScreen);
  //   gameAssets.gameScreen.addChild(instances.PopUpMessage.popUpContainer);


  const style = new PIXI.TextStyle({
    dropShadow: true,
    dropShadowBlur: 10,
    dropShadowColor: "#252525",
    dropShadowDistance: 10,
    stroke: "#D75E08",
    strokeThickness: 2,
    fill: "#F9B41E",
    fontFamily: "Arial",
    fontSize: 70,
    fontWeight: "900",
    align: "center",
    fontStyle: "italic",
  });

  gameAssets.clickText = new PIXI.Text("TAP TO START", style);
  gameAssets.clickText.anchor.set(0.5);
  gameAssets.clickText.y = 935
  gameAssets.clickText.text = "CONNECTING..."
  // clickText.visible = false;
  gameAssets.loadingScreen.addChild(gameAssets.clickText);
  gameAssets.loadingScreen.interactive = false
  gameAssets.loadingScreen.on('pointerdown', (event) => {
    if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
      disableLoadingScreen()
    }
  })
}

function pendingGameUpdate(multiplier = 0) {
  // gameAssets.loadingScreen.children[0].text = "TAP TO START"
  const style = new PIXI.TextStyle({
    dropShadow: true,
    dropShadowBlur: 10,
    dropShadowColor: "#252525",
    dropShadowDistance: 10,
    stroke: "#D75E08",
    strokeThickness: 2,
    fill: "#F9B41E",
    fontFamily: "Arial",
    fontSize: 70,
    fontWeight: "900",
    align: "center",
    fontStyle: "italic",
  });

  gameAssets.clickText.visible = false;
  const clickText = new PIXI.Text("TAP TO START", style);
  clickText.anchor.set(0.5);
  clickText.y = 935
  gameAssets.loadingScreen.addChild(clickText);
  gameAssets.loadingScreen.interactive = true;
  gameAssets.loadingScreen.cursor = 'pointer';
  // resumeMeter(multiplier);
}

function toggleVisibility(gameObject, isVisible, duration = 0.5) {
  if (isVisible) {
    gameObject.visible = true
    gameObject.alpha = isVisible ? 0 : 1
  }

  resolveAndKillTweens(gameObject)
  const tl = gsap.timeline()
  tl.to(gameObject, {
    alpha: isVisible ? 1 : 0,
    duration,
    ease: 'sine.in',
    onComplete: () => {
      gameObject.visible = isVisible
      return
    }
  })
}

function toggleBetPanel() {
  if (!gameAssets.betPanelPopup.visible) {
    playTap(true)
    toggleVisibility(gameAssets.betPanelPopup, true)
  } else {
    playOff(true)
    toggleVisibility(gameAssets.betPanelPopup, false)
  }
}

function toggleRoundPanel() {
  if (!gameAssets.roundPanelPopup.visible) {
    playTap(true)
    toggleVisibility(gameAssets.roundPanelPopup, true)
  } else {
    playOff(true)
    toggleVisibility(gameAssets.roundPanelPopup, false)
  }
}

export function disableLoadingScreen() {
  // gameAssets.loadingScreen.visible = false;
  clearInterval(timeOut);
  tweenFadeAppear(gameAssets.loadingScreen, false);

  //gameAssets.CoinsContainer.visible = true

  gsap.delayedCall(0.15, () => {
    tweenFadeAppear(gameAssets.gameUI, true)
  });

  if (!fruitData.gameLanguage) {
    gameAssets.popupDimmer.visible = true;
    gameAssets.popupDimmer.alpha = 1;
    instances.FTUE.ftueContainer.visible = true;
  }

  if (fruitData.isJackpotActive && fruitData.gameLanguage) {
    showJackpotPanel()
    if (!fruitData.jackpotMinorWin) showMinorJackpotWin(fruitData.minorCurrentJackpotValue)
    if (!fruitData.jackpotMajorWin) showMajorJackpotWin(fruitData.majorCurrentJackpotValue)
    if (!fruitData.jackpotGrandWin) showGrandJackpotWin(fruitData.grandCurrentJackpotValue)
  } else {
    hideJackpotPanel();
  }
  gameAssets.menubarButton.visible = true;

  scheduleAmbient();

}

function scheduleAmbient() {
  const delay = Math.floor(Math.random() * (18000 - 11000 + 1)) + 11000;

  gameAssets.ambientTimeout = setTimeout(() => {
    playAmbient(true);
    scheduleAmbient();
  }, delay);
}


function resizeGameUI() {
  if (window.innerWidth < 500) {
    gameAssets.gameScreen.x = 0
    gameAssets.gameUI.x = window.innerWidth / 2 + 0.5
    const scaleX = window.innerWidth / config.logicalWidth;

    gameAssets.gameScreen.scale.set(scaleX, config.minScaleFactor);
    gameAssets.gameUI.scale.set(scaleX * 2.977)
  } else {

    gameAssets.gameScreen.x = config.minLeftX;
    gameAssets.gameScreen.scale.set(config.minScaleFactor);
    gameAssets.gameUI.scale.set(config.minScaleFactor * 2.977)
    gameAssets.gameUI.x = window.innerWidth / 2 + 0.5
    gameAssets.gameUI.initialX = gameAssets.gameUI.finalX = gameAssets.gameUI.x
  }
  gameAssets.gameScreen.y = config.minTopY;
  gameAssets.popupContainer.y = window.innerHeight / 2
  gameAssets.popupContainer.x = window.innerWidth / 2

  gameAssets.CoinsContainer.y = window.innerHeight / 2
  gameAssets.CoinsContainer.x = window.innerWidth / 2

  gameAssets.popupContainer.scale.set(config.minScaleFactor * 2)

  if (fruitData.isJackpotActive) {
    instances.JackpotPanel.jackpotPanelSprite.scale.set(config.minScaleFactor)
    instances.JackpotPanel.jackpotPanelSprite.x = window.innerWidth / 2 + (90 * config.minScaleFactor)
    instances.JackpotPanel.jackpotPanelSprite.y = instances.JackpotPanel.jackpotPanelSprite.height / 2 + 10
  }

  gameAssets.menubarButton.scale.set(config.minScaleFactor * 1.15)
  gameAssets.menubarButton.x = window.innerWidth / 2 - (625 * config.minScaleFactor)
  gameAssets.menubarButton.y = 10 + gameAssets.menubarButton.height / 2

  gameAssets.gameUI.y = window.innerHeight / 2 * 2 + 15
  gameAssets.gameUI.initialY = gameAssets.gameUI.finalY = gameAssets.gameUI.y
}

function hideJackpotPanel(winAmount, duration) {
  if (instances.JackpotPanel)
    instances.JackpotPanel.jackpotPanelContainer.visible = false;
}

function showJackpotPanel(winAmount, duration) {
  if (instances.JackpotPanel)
    instances.JackpotPanel.jackpotPanelContainer.visible = true;
}

function resetJackpotPanel() {
  if (instances.JackpotPanel)
    instances.JackpotPanel.resetPanel()
}
function showGrandJackpotWin(winAmount, duration) {
  if (instances.JackpotPanel)
    instances.JackpotPanel.showGrandWin(winAmount, duration)
}

function showMajorJackpotWin(winAmount, duration) {
  if (instances.JackpotPanel)
    instances.JackpotPanel.showMajorWin(winAmount, duration)
}

function showMinorJackpotWin(winAmount, duration) {
  if (instances.JackpotPanel)
    instances.JackpotPanel.showMinorWin(winAmount, duration)
}

function controlJackpotWinSpine(winTypeIndex, play) {
  if (instances.JackpotPanel) {
    if (winTypeIndex === 2 && play)
      instances.JackpotPanel.showGrandWinSpine();
    else
      instances.JackpotPanel.hideGrandWinSpine();
    if (winTypeIndex === 1 && play)
      instances.JackpotPanel.showMajorWinSpine();
    else
      instances.JackpotPanel.hideMajorWinSpine();
    if (winTypeIndex === 0 && play)
      instances.JackpotPanel.showMinorWinSpine();
    else
      instances.JackpotPanel.hideMinorWinSpine();
  }
}

function parseJackpotResult() {
  if (fruitData.jackpotGrandWin) {
    fruitData.jackpot = true;
    fruitData.jackpotWin = fruitData.jackpotGrandWinAmount;
  } else if (fruitData.jackpotMajorWin) {
    fruitData.jackpot = true;
    fruitData.jackpotWin = fruitData.jackpotMajorWinAmount;
  } else if (fruitData.jackpotMinorWin) {
    fruitData.jackpot = true;
    fruitData.jackpotWin = fruitData.jackpotMinorWinAmount;
  } else {
    fruitData.jackpot = false;
    fruitData.jackpotWin = 0;
  }

}

function checkGrandJackpotVisible() {
  return instances.winScreen.grandJackpotSpine.visible
}

export { createAppUI, containers, toggleButtons, checkGrandJackpotVisible, controlJackpotWinSpine, hideJackpotPanel, showJackpotPanel, resetJackpotPanel, parseJackpotResult, checkBalanceColor, showGrandJackpotWin, showMajorJackpotWin, showMinorJackpotWin, triggerRapidFruitFall, startFruitLauncher, stopFruitLauncher, resizeGameUI, gameAssets, toggleVisibility, scheduleAmbient, instances, uiCreated, updateBalance, pendingGameUpdate, setSessionExpired, playAnimations, showErrorPopup, startCircularTimer, launchFruit }